import { useLocation, useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Loading from "../../components/Loading/Loading";
import BASE_URL from "../../configs/api";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { getProxyUrl } from "../../utils/proxy";

const TopicMovie = () => {
  const { name } = useParams();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const the_loai = queryParams.get("the_loai");
  const nam_phat_hanh = queryParams.get("nam_phat_hanh");
  const [phimCategory, setPhimCategory] = useState({ results: [], count: 0 });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 24;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCurrentPage(1);
  }, [name, search]);

  useEffect(() => {
    const fetchPhimCategory = async () => {
      setLoading(true);
      try {
        const params = { page: currentPage, limit: itemsPerPage };

        const qParam = queryParams.get("q") || name;
        if (qParam) params.q = qParam;

        const ngon_ngu = queryParams.get("ngon_ngu");
        if (ngon_ngu) params.ngon_ngu = ngon_ngu;

        const tinh_trang = queryParams.get("tinh_trang");
        if (tinh_trang) params.tinh_trang = tinh_trang;

        const sort = queryParams.get("sort");
        if (sort) params.sort_by = sort;

        const nam_phat_hanh = queryParams.get("nam_phat_hanh");
        if (nam_phat_hanh) params.nam_phat_hanh = nam_phat_hanh;

        const quoc_gia = queryParams.get("quoc_gia");
        if (quoc_gia) params.quoc_gia = quoc_gia;

        if (the_loai) params.the_loai = the_loai;

        const response = await axios.get(`${BASE_URL}/api/filtersearch/`, {
          params,
        });
        const data = response.data || {};
        setPhimCategory({
          results: data.results || [],
          count: data.count || 0,
        });
      } catch (error) {
        setPhimCategory({ results: [], count: 0 });
      } finally {
        setLoading(false);
      }
    };

    fetchPhimCategory();
  }, [name, search, currentPage, the_loai]);

  const totalPages = Math.ceil((phimCategory.count || 0) / itemsPerPage);

  const goToPrevPage = () => setCurrentPage((p) => Math.max(p - 1, 1));
  const goToNextPage = () => setCurrentPage((p) => Math.min(p + 1, totalPages));

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0f1015] text-white">
        <div className="text-center">
          <h1 className="text-xl lg:text-6xl font-bold text-yellow-300 mb-4 animate-bounce">
            Đang tải đợi xíu
          </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="xl:container xl:mx-auto p-4 py-16 xl:py-24 min-h-screen">
      <div className="p-3.5 rounded-lg mt-4 mb-4 w-full h-auto bg-[#2a2d42] bg-opacity-50">
        <nav className="text-sm text-white">
          <Link to="/" className="hover:underline hover:text-yellow-400">
            Trang chủ
          </Link>

          {name ? (
            <>
              <span className="mx-2">{">"}</span>
              <span className="text-white">{name}</span>
            </>
          ) : the_loai ? (
            <>
              <span className="mx-2">{">"}</span>
              <span className="text-white">{the_loai}</span>
            </>
          ) : nam_phat_hanh ? (
            <>
              <span className="mx-2">{">"}</span>
              <span className="text-white">Phim: {nam_phat_hanh}</span>
            </>
          ) : null}
        </nav>
      </div>

      <h2 className="text-lg lg:text-2xl bg-gradient-to-r from-yellow-300 to-white bg-clip-text text-transparent font-bold mb-6 md:mb-8 border-l-4 border-yellow-400 pl-3">
        {name
          ? `Chủ đề: "${name}"`
          : queryParams.get("q")
          ? `Kết quả tìm kiếm: "${queryParams.get("q")}"`
          : "Danh sách phim"}
        <span className="ml-2 text-lg lg:text-2xl font-bold">
          - {phimCategory.count || 0} Bộ Phim
        </span>
      </h2>

      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4 md:gap-6">
        {phimCategory.results?.map((movie) => (
          <div
            key={movie.id}
            className="movie-card transition-transform duration-200 ease-in-out"
          >
            <div className="relative rounded-lg overflow-hidden group">
              <Link
                to={`/phim/${movie.id}?ten_phim=${encodeURIComponent(
                  movie.ten_phim
                )}`}
              >
                <div className="relative">
                  <img
                    src={movie.poster_url || getProxyUrl(movie.poster)}
                    alt={(movie.ten_phim)}
                    className="w-full h-auto aspect-[2/3] object-cover"
                  />
                  <div className="absolute bottom-1 left-2 flex flex-row gap-1 justify-center items-start z-20">
                    <div className="bg-teal-700 text-white text-[8px] leading-[10px] md:text-[10px] font-semibold px-2 py-0.5 lg:py-1 rounded-lg shadow-md">
                      {movie.ngon_ngu
                        ? movie.ngon_ngu
                            .replace("Vietsub", "PĐ")
                            .replace("Lồng Tiếng", "TM")
                            .replace("Thuyết Minh", "TM")
                        : "Đang cập nhật"}
                    </div>

                    <div className="bg-orange-200 text-orange-900 text-[8px] leading-[10px] md:text-[10px] font-semibold px-2 py-0.5 lg:py-1 rounded-lg shadow-md">
                      {(movie.tinh_trang || "Đang cập nhật")
                        .replace(/Hoàn Tất/gi, "Full")
                        .trim() || "Đang cập nhật"}
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition duration-300" />
                </div>
              </Link>
            </div>
            <div className="mt-2 text-center">
              <Link
                to={`/phim/${movie.id}`}
                className="text-white text-sm font-medium truncate hover:text-yellow-200 cursor-pointer line-clamp-none"
                title={movie.ten_phim}
              >
                {movie.ten_phim}
              </Link>
              <p
                className="text-gray-400 text-xs truncate"
                title={(movie.ten_khac)}
              >
                {movie.ten_khac}
              </p>
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex flex-row justify-center items-center mt-10 md:mt-12 space-x-3 sm:space-x-4">
          <button
            onClick={goToPrevPage}
            disabled={currentPage === 1}
            className="inline-flex items-center justify-center px-3 py-1.5 sm:px-4 sm:py-2 bg-neutral-700/90 text-neutral-200 rounded-md shadow-sm border border-neutral-600/80 transition-all duration-200 ease-in-out text-sm hover:bg-neutral-600/90 hover:text-white hover:border-neutral-500 disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Trang trước"
          >
            <FiChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-1.5 flex-shrink-0" />
            <span>Trước</span>
          </button>

          <span className="text-neutral-300 font-semibold text-sm sm:text-base px-2 py-1 bg-neutral-800/50 rounded-md border border-neutral-700">
            {`${currentPage} / ${totalPages}`}
          </span>

          <button
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
            className="inline-flex items-center justify-center px-3 py-1.5 sm:px-4 sm:py-2 bg-neutral-700/90 text-neutral-200 rounded-md shadow-sm border border-neutral-600/80 transition-all duration-200 ease-in-out text-sm hover:bg-neutral-600/90 hover:text-white hover:border-neutral-500 disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Trang sau"
          >
            <span>Sau</span>
            <FiChevronRight className="w-4 h-4 sm:w-5 sm:h-5 ml-1 sm:ml-1.5 flex-shrink-0" />
          </button>
        </div>
      )}
    </div>
  );
};

export default TopicMovie;
